// 已选择的条件
import React from 'react'

import { sendTeaCommEvent } from 'lib/tea-analyze'

import { ContextStore } from './reducer'
import { IOptionsState, IOptionProps } from './interface'

interface Props extends IOptionProps {
  initOptions: IOptionsState
}

export default function Select() {
  const { state, dispatch } = React.useContext(ContextStore)
  const entries = Object.entries(state)

  const filterList = ['sort', 'sub_brand_id']

  if (
    !entries ||
    !entries.length ||
    !entries.filter(([key]) => filterList.indexOf(key) === -1).length
  ) {
    return null
  }

  return (
    <div className="selected clearfix">
      <span className="label fl">已选条件：</span>
      <span
        className="reset"
        onClick={() => {
          sendTeaCommEvent('click_garage_series_selector_clear')
          dispatch({
            type: 'clearOptions',
          })
        }}
      >
        <span className="icon-delete-ic-new empty-icon" />
        清空条件
      </span>
      <div className="conditions">
        {Object.entries(state).map(([key, value]) => {
          if (filterList.indexOf(key) > -1) {
            return null
          }
          if (!value || !value.length) {
            return null
          }
          return value.map(item => (
            <span
              key={item.text}
              className="container"
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.stopPropagation()
                e.preventDefault()
                dispatch({
                  type: 'removeOption',
                  payload: {
                    key,
                    param: item.param,
                  },
                })
              }}
            >
              {item.text}
              <span className="icon-dislike-ic delete-icon" />
            </span>
          ))
        })}
      </div>
      <style jsx>
        {`
          .selected {
            border-radius: 2px;
            border: 1px solid #ededed;
          }
          .label {
            display: inline-block;
            margin: 12px 2px 12px 8px;
            color: #666;
          }
          .reset {
            float: right;
            margin: 12px 8px 12px 0;
            cursor: pointer;
          }
          .empty-icon {
            font-size: 24px;
            margin-top: -6px;
            margin-right: 4px;
            width: 15px;
            min-width: 15px;
            height: 15px;
            margin-right: 4px;
            background-image: url(${require('static/delete-ic-new.svg')});
            background-size: cover;
          }
          .reset:hover {
            color: #e65800;
          }
          .conditions {
            width: 700px;
            min-height: 36px;
            margin: 8px 0 0 80px;
          }
          .conditions span.container {
            display: inline-block;
            padding: 4px 4px 4px 8px;
            margin-right: 8px;
            margin-bottom: 8px;
            border-radius: 2px;
            background-color: #fff5d6;
            cursor: pointer;
          }
          .icon-delete-ic-new {
            display: inline-block;
            font-size: 20px;
            vertical-align: middle;
            margin-top: -3px;
          }
          .delete-icon {
            font-size: 16px;
            margin-left: 4px;
            margin-top: -2px;
          }
        `}
      </style>
    </div>
  )
}
